import "./App.css";
import ToDoApp from "./Component/ToDoApp";
function App() {
  return (
    <div className="App">
      <h1>ToDo App</h1>
      <ToDoApp />
    </div>
  );
}

export default App;
